export default "__VITE_ASSET__yzB_6ppf__"